import PropTypes from 'prop-types';
import React from 'react';
import './TooltipButton.style.scss';

const TooltipButton = (props) => {
  return (
    <span className="tooltip-container">
      <span
        className={props.info ? 'tooltip' : 'hidden'}
        data-testid="btn-tooltip"
      >
        i{' '}
        <span className="tooltiptext">
          {props.info}
          <span className="arrow" />
        </span>
      </span>
    </span>
  );
};

TooltipButton.propTypes = {
  info: PropTypes.string
};

export default TooltipButton;
